module.exports = __webpack_public_path__ + "img/mood_hurt.214ff080.png";